import React from 'react'
import { Message, ThemedIcon } from '../../../ui'
import { useTranslation } from 'react-i18next'
import { useRedirectIn10Sec } from '../../utils/hooks'
import { compose, find, propEq } from 'ramda'
import { filterByTier, filterFlagFields, getTextByLang } from '../../ExternalFields'
import { useStore } from '../../../StateProvider'
import { TARGET_PLATFORMS } from '../../../constants/constants'
import { tByPlatform } from '../../../i18n/i18nUtils'
import styles from './style.css'

const RegisterSuccessMessage = ({ accountCreatedWithRemarks }) => {
  const { t } = useTranslation()
  const [
    {
      whitelabel: {
        email,
        immediateLoginEnabled,
        emailSenderAddress,
        targetPlatform,
        extFields,
        customTexts,
        whiteLabelName
      }
    }
  ] = useStore()

  const redirect = compose(
    find(propEq('name', 'shouldRedirectIn10Sec')),
    filterFlagFields,
    filterByTier(1)
  )(extFields)

  useRedirectIn10Sec(redirect)

  const mt4Key = targetPlatform === TARGET_PLATFORMS.MT4 ? 'Mt4' : ''
  if (immediateLoginEnabled) {
    return (
      <article className={styles.message}>
        <div className={styles.headerRow}>
          <div>
            <ThemedIcon kind='mail' />
          </div>
          <h1 className={styles.header}>{t(`createAccount.checkEmailP1${mt4Key}`)}</h1>
        </div>
        <ul className={styles.messageUl}>
          <li>
            {t(`createAccount.checkEmailP2${mt4Key}`)}
            <a href={`mailto:${email}`}>{emailSenderAddress}</a>
          </li>
          <li>
            {t('createAccount.checkEmailP3')} <a href={`mailto:${email}`}>{email}</a>
          </li>
        </ul>
      </article>
    )
  } else {
    const copyright = getTextByLang('copyright', customTexts) || whiteLabelName
    const checkEmailCustom = getTextByLang('checkEmailCustom', customTexts)
    const checkEmailText = getTextByLang('checkEmailSt1', customTexts)
    const title = checkEmailCustom || (
      <>
        {checkEmailText || t(tByPlatform(targetPlatform, 'createAccount.checkEmailSt1'), { copyright })}
        <br />
        {t(tByPlatform(targetPlatform, 'createAccount.checkEmailSt2'))}
      </>
    )
    return <Message title={title} className={styles.successMessage} />
  }
}

export default RegisterSuccessMessage
